import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {RewardService} from "../../../../../shared/services/reward.service";
import {ParamService} from "../../../../../shared/services/param.service";
import {properties} from "../../../../../../environments/properties";

@Component({
  selector: 'app-promotion-terms',
  templateUrl: './promotion-terms.component.html',
  styleUrls: ['./promotion-terms.component.scss']
})
export class PromotionTermsComponent implements OnInit {

    @Input() partnerDetails: any;
    partnerDetailContentURL: any;
    termsContent: any;
    showLoading = true;
    isErrorInContent = false;
    @Input() isWebView;
    displayableBanner: string = '';
    @Output() partnertermsObject: EventEmitter<any> = new EventEmitter();
    constructor(private rewardService: RewardService, private paramService: ParamService) { }

    ngOnInit(): void {
        this.displayableBanner = properties.rewardsConfig.displaybleBannerNames[this.partnerDetails.banner];
        if (this.partnerDetails) {
            if (this.partnerDetails.contentPath) {
              this.partnerDetailContentURL = this.partnerDetails.contentPath;
              if(this.isWebView) {
                this.partnerDetailContentURL = this.rewardService.getMobileApplicationDomainURL(this.partnerDetails.currentEnvironment, this.partnerDetails.banner) + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'terms-conditions');
              } else {
                this.partnerDetailContentURL = this.rewardService.getApplicationDomainURL() + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'terms-conditions');
              }
              this.getPartnerDetailContentAPI();
            }
        }
    }

    @HostListener('document:click', ['$event', '$event.target'])
    public onDocumentClick(event: MouseEvent, targetElement: HTMLElement): void {
        let hrefVal;
        const clickedElement = targetElement.parentElement.nodeName;
        if (clickedElement === 'PICTURE') {
            hrefVal = targetElement.parentElement.parentElement.attributes['href'].value;
        } else if (clickedElement === 'A') {
            hrefVal = targetElement.parentElement.attributes['href'].value;
        } else if (clickedElement === 'P') {
            hrefVal = targetElement.attributes['href'].value
        }
        if(hrefVal) {
            if (this.isWebView) {
                var responseJson = {
                    respCode: 4,
                    status: "ok",
                    event: 'privacy-policy',
                    external: true,
                    url: hrefVal

                }
                this.partnertermsObject.emit(responseJson);
            }
        }
    }

    getPartnerDetailContentAPI(){
        this.rewardService.getPromotionDetailContent(this.partnerDetailContentURL).subscribe((promotionDetailData: any) => {
            if(promotionDetailData){
                this.showLoading = false;
                this.termsContent = this.rewardService.replaceBannerInContent(promotionDetailData, this.partnerDetails.banner);
            }
        }, error => {
                     this.showLoading = false;
                     this.isErrorInContent = true;
                });
    }
}
